<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :hasButtons="false"
  >
    <template #[`tabs.input`]>
      <grey-tabs v-model="tab" :tabs="tabs" has-border cols="auto">
        <v-tab-item>
          <modeling-results-ranges-settings type="water" v-bind="{ ...modelingResultsParamsNames }" />
        </v-tab-item>
        <v-tab-item>
          <admin-wrapper
            title-translation-path="admin.epanetLabels"
            :inputs="epanetInputs"
            @save="save('epanet')"
            @setPayloadValue="setEpanetPayload"
            disable-sticky-buttons
          />
        </v-tab-item>
        <v-tab-item v-if="ekartExportEnabled">
          <admin-wrapper
            title-translation-path="admin.waterModelingEkartConnection"
            :inputs="eKartInputs"
            @save="save('ekart')"
            @setPayloadValue="setEkartPayload"
            disable-sticky-buttons
          />
        </v-tab-item>
      </grey-tabs>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';
import waterModelingEkartParams from '@/mixins/waterModelingEkartParams';

import AdminWrapper from '@/components/AdminWrapper';
import GreyTabs from '@/components/GreyTabs';
import ModelingResultsRangesSettings from '@/components/ModelingResultsRangesSettings';
export default {
  name: 'WaterModelingSettings',
  components: {
    AdminWrapper,
    GreyTabs,
    ModelingResultsRangesSettings,
  },
  mixins: [waterModelingEkartParams],
  computed: {
    additionalModuleName: get('admin/additionalModules.WATER_MODELING.verbose_name'),
    epanetTags: get('admin/settingsValues@epanet_tags_format'),
    ekartOptions: get('admin/settingsValues@water_modeling_ekart_options'),
    ekartExportEnabled: get('admin/settingsValues@water_modeling_ekart_export_enabled'),
    waterModelingWaterQualityEnabled: get('admin/settingsValues@epanet_water_quality_enabled'),
    epanetTagsArray() {
      return Object.keys(this.epanetTags);
    },
    epanetInputs() {
      return this.epanetTagsArray.map(tag => ({
        isCustom: true,
        name: 'epanet_tags_format',
        valueSubproperty: tag,
        translationPath: `admin.${tag}`,
        dataType: {
          name: 'text',
        },
      }));
    },
    eKartInputs() {
      return Object.values(this.eKartParams).map(param => ({
        ...param,
        isCustom: true,
        name: 'water_modeling_ekart_options',
        valueSubproperty: param.name,
      }));
    },
    modelingResultsParamsNames() {
      return {
        linksParams: [
          'flow',
          'headloss',
          'velocity',
          ...(this.waterModelingWaterQualityEnabled ? ['age', 'chemical', 'trace'] : []),
        ],
        nodesParams: [
          'hydraulic_grade',
          'pressure',
          ...(this.waterModelingWaterQualityEnabled ? ['age', 'chemical', 'trace'] : []),
        ],
      };
    },
    moduleEnabler() {
      return {
        name: 'water_modeling_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    inputs() {
      return [
        {
          name: 'tabs',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    tabs() {
      return [
        { name: this.$i18n.t('admin.waterModelingResultsBrowser') },
        { name: 'EPANET' },
        ...(this.ekartExportEnabled ? [{ name: this.$i18n.t('admin.waterModelingEkartExport') }] : []),
      ];
    },
  },
  data: () => ({
    epanetPayload: {},
    ekartPayload: {},
    tab: 0,
  }),
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    async save(type = 'epanet') {
      try {
        this.$root.$emit('adminSavingON');
        await this.editSingleSetting({
          key: type === 'epanet' ? 'epanet_tags_format' : 'water_modeling_ekart_options',
          body: {
            value: type === 'epanet' ? this.epanetPayload : this.ekartPayload,
          },
        });
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successEditSetting'),
        });
        this.$root.$emit('adminSavingOFF');
      } catch (error) {
        this.$root.$emit('adminSavingOFF');
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.settingChangeFailed'),
        });
        console.log(error);
      }
    },
    setEpanetPayload({ value, subproperty }) {
      this.epanetPayload = { ...this.epanetPayload, [subproperty]: value };
    },
    setEkartPayload({ value, subproperty }) {
      this.ekartPayload = { ...this.ekartPayload, [subproperty]: value };
    },
  },
};
</script>
